
































import CertCard from '@/components/card/CertCard.vue'
import Translation from '@/mixins/Translation'
import ListItem from '@/components/list/ListItem.vue'
import {namespace} from '@@/node_modules/vuex-class'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import toTaxStatusColor from '@/filters/to-tax-status-color'
import toTaxStatusTaxtColor from '@/filters/to-tax-status-text-color'
import toInvoiceStatusColor from '@/filters/to-invoice-status-color'
import toInvoiceStatusTextColor  from '@/filters/to-invoice-status-text-color'
import {
  UserPropertyPayload,
  BizPropertyPayload,
  LogEventWidthGroupsPayload,
} from '@/store/modules/gtm/types'

const gtm = namespace('gtm')

@Component({
  components: {CertCard, BttPopup, ListItem},
})
export default class ChangeStatusPopup extends Mixins(Translation) {
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: 'components.popup.change-status-popup'}) translation: string
  @Prop({default: '', type: String}) title: string
  @Prop({default: '', type: String}) selectedStatus: string
  @Prop({default: '', type: String}) selectedId: string
  @Prop({default: '', type: String}) type: 'tax' | 'invoice'

  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void
  @gtm.Action('setUserProperty') setUserProperty: (payload: UserPropertyPayload) => void
  @gtm.Action('setBizProperty') setBizProperty: (payload: BizPropertyPayload) => void

  open: boolean = true
  loading: boolean = false

  get taxStatusList() {
    const {ts, selectedStatus, type} = this
    let changeStatusList: string[] = []
    if(selectedStatus === 'completed') {
      changeStatusList = ['pending']
    } else {
      changeStatusList = ['completed']
    }
    changeStatusList.unshift(selectedStatus)
    return changeStatusList.map((status) => {
      return {
        status,
        text: ts(`${type}-status.${status}`),
        description: ts(`${type}-description.${status}`),
        color: toTaxStatusColor(status),
        textColor: toTaxStatusTaxtColor(status),
      }
    })
  }

  get invoiceStatusList() {
    const {ts, selectedStatus, type} = this
    let changeStatusList: string[] = []
    if(selectedStatus === 'completed') {
      changeStatusList = ['pending', 'excluded']
    } else if(selectedStatus === 'excluded') {
      changeStatusList = ['pending', 'completed']
    } else if(selectedStatus === 'unavailable') {
      changeStatusList = ['excluded']
    } else {
      changeStatusList = ['completed', 'excluded']
    }
    changeStatusList.unshift(selectedStatus)
    return changeStatusList.map((status) => {
      return {
        status,
        text: ts(`${type}-status.${status}`),
        description: ts(`${type}-description.${status}`),
        color: toInvoiceStatusColor(status),
        textColor: toInvoiceStatusTextColor(status),
      }
    })
  }

  get statusList() {
    return this.type === 'tax' ? this.taxStatusList : this.invoiceStatusList
  }

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
  }

  isSelected(status): boolean {
    return this.selectedStatus === status
  }

  onClickCancel() {
    this.close()
  }

  close() {
    this.open = false
  }

  onClickStatusItem(status) {
    if(!this.isSelected(status)) {
      this.$emit('change-status', status)
      this.sendAmplitude(status)
    }
    this.close()
  }

  sendAmplitude(status) {
    const {type, selectedId} = this
    this.logEventWithGroups({
      eventType: 'change_status',
      eventProperties: {
        'item_id': selectedId,
        'target': type,
        'status': status,
      }
    })
    const addCount = 1
    const userAndBizProperty = {
      [`${this.type}StatusChangeCount`]: addCount
    }
    this.setUserProperty({
      event: 'addUserProperty',
      userProperty: userAndBizProperty
    })

    this.setBizProperty({
      event: 'addBizProperty',
      bizProperty: userAndBizProperty,
    })
  }
}
